var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container p-15" }, [
    _c("div", { staticClass: "col-xs-12 col-md-6 col-md-offset-3 well" }, [
      _c(
        "h4",
        {
          staticClass: "title text-center",
          staticStyle: { "margin-top": "0px" },
        },
        [_vm._v("Inscription")]
      ),
      _vm._v(" "),
      _c("form", [
        _c("div", { staticClass: "form-group" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.new_cardno,
                expression: "new_cardno",
              },
            ],
            staticClass: "form-control",
            attrs: {
              type: "text",
              name: "",
              placeholder: "Numéro de carte/Email*",
            },
            domProps: { value: _vm.new_cardno },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.new_cardno = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "text-danger",
              staticStyle: { "margin-top": "10px" },
            },
            [_vm._v(_vm._s(_vm.new_cardno_msg))]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary btn-block",
              attrs: { type: "submit" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.registerCard()
                },
              },
            },
            [
              _vm._v("\n\t\t\t\t\tEnregistrer ma carte "),
              _c("i", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.registerProcessing,
                    expression: "registerProcessing",
                  },
                ],
                staticClass: "loading",
              }),
            ]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-xs-12 col-md-6 col-md-offset-3 well" }, [
      _c(
        "h4",
        {
          staticClass: "title text-center",
          staticStyle: { "margin-top": "0px" },
        },
        [_vm._v("Accédez à votre compte")]
      ),
      _vm._v(" "),
      _c("form", [
        _c("div", { staticClass: "form-group" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.cardno,
                expression: "cardno",
              },
            ],
            staticClass: "form-control",
            attrs: {
              type: "text",
              name: "login_cardno",
              placeholder: "Numéro de carte*",
            },
            domProps: { value: _vm.cardno },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.cardno = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "text-danger",
              staticStyle: { "margin-top": "10px" },
            },
            [_vm._v(_vm._s(_vm.cardno_msg))]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.login,
                expression: "login",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "text", name: "email", placeholder: "Email/Mobile" },
            domProps: { value: _vm.login },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.login = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "text-danger",
              staticStyle: { "margin-top": "10px" },
            },
            [_vm._v(_vm._s(_vm.login_msg))]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary btn-block",
              attrs: { type: "submit" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.doLogin()
                },
              },
            },
            [
              _vm._v("\n\t\t\t\t\tConsulter mon solde "),
              _c("i", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.loginProcessing,
                    expression: "loginProcessing",
                  },
                ],
                staticClass: "loading",
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-block btn-default",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.sendCardnoReminder(_vm.login)
                },
              },
            },
            [
              _vm._v("\n\t\t\t\t\tJ'ai oublié mon numéro de carte "),
              _c("i", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.reminderProcessing,
                    expression: "reminderProcessing",
                  },
                ],
                staticClass: "loading",
              }),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }